export default __webpack_public_path__ + "static/media/loader_large.af12e3de.gif";